var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8281 17.8125H20.1875V12.1719C20.1875 12.0086 20.0539 11.875 19.8906 11.875H18.1094C17.9461 11.875 17.8125 12.0086 17.8125 12.1719V17.8125H12.1719C12.0086 17.8125 11.875 17.9461 11.875 18.1094V19.8906C11.875 20.0539 12.0086 20.1875 12.1719 20.1875H17.8125V25.8281C17.8125 25.9914 17.9461 26.125 18.1094 26.125H19.8906C20.0539 26.125 20.1875 25.9914 20.1875 25.8281V20.1875H25.8281C25.9914 20.1875 26.125 20.0539 26.125 19.8906V18.1094C26.125 17.9461 25.9914 17.8125 25.8281 17.8125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.375C9.81914 2.375 2.375 9.81914 2.375 19C2.375 28.1809 9.81914 35.625 19 35.625C28.1809 35.625 35.625 28.1809 35.625 19C35.625 9.81914 28.1809 2.375 19 2.375ZM19 32.8047C11.3777 32.8047 5.19531 26.6223 5.19531 19C5.19531 11.3777 11.3777 5.19531 19 5.19531C26.6223 5.19531 32.8047 11.3777 32.8047 19C32.8047 26.6223 26.6223 32.8047 19 32.8047Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/PlusCircle.263acbf623d1cba6ff60d1445f2d0a3e.svg";
export { ForwardRef as ReactComponent };